module.exports = __webpack_public_path__ + "static/media/ideas_logo.4c689a96.png";